import { useI18n } from '../app/context';
import { Icon } from '../components/Icon';
import { missingConfigKeys } from '../firebase';
import styles from './auth.module.css';

/** Shown before anything else when .env.local has not been filled in. */
export function ConfigError() {
  const { t } = useI18n();

  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.lockIcon}>
            <Icon name="sliders" size={22} />
          </span>
          <h1 className={styles.heading}>{t('error.notConfigured.title')}</h1>
          <p className={styles.body}>{t('error.notConfigured.body')}</p>
        </div>

        <div className={styles.block}>
          <span className="eyebrow">{t('error.missingKeys')}</span>
          <div className={styles.missingList}>
            {missingConfigKeys.map((key) => (
              <span key={key}>{key}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
